import React from 'react';
import './css/Preloader.css';

const Preloader = () => {
  return (
    <div className="preloader">
      <div class="wrappeer">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
      </div>
    </div>
  );
};

export default Preloader;
